import gql from 'graphql-tag';


export const GET_VISIBLE_CATEGORIES = gql`
  query visibleCategories {
    visibleCategories {
      id
      name
      slug
      parent_id
      sort_order
      is_visible
    }
  }
`;
